export default "__VITE_ASSET__BJYvGUbJ__"